import * as style from './Expired.module.css';

export default function Expired() {
    return <div className={style.expired}>Utgått</div>;
}
